import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkle, X } from "@phosphor-icons/react";

const STORAGE_KEY = "exodus_exit_intent_seen_v1";

/**
 * Triggers a soft modal when the user moves the cursor toward the top of the
 * viewport (likely exit). Shows once per session. Suppressed for advisor pages.
 */
export default function ExitIntent() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    if (loc.pathname.startsWith("/dashboard") || loc.pathname.startsWith("/quiz") || loc.pathname.startsWith("/login") || loc.pathname.startsWith("/reserve")) return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    let timer = null;
    const onMove = (e) => {
      if (e.clientY <= 8 && !timer) {
        timer = setTimeout(() => {
          if (!sessionStorage.getItem(STORAGE_KEY)) {
            setOpen(true);
            sessionStorage.setItem(STORAGE_KEY, "1");
          }
        }, 250);
      }
    };
    document.addEventListener("mouseleave", onMove);
    return () => document.removeEventListener("mouseleave", onMove);
  }, [loc.pathname]);

  if (!open) return null;
  return (
    <div
      data-testid="exit-intent-modal"
      className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-6"
      onClick={() => setOpen(false)}
    >
      <div
        className="bg-exodus-bg border border-exodus-gold max-w-lg w-full p-10 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="exit-intent-close"
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 text-exodus-muted hover:text-exodus-text"
          aria-label="Close"
        >
          <X size={20} />
        </button>
        <div className="flex items-center gap-2 mb-4">
          <Sparkle size={18} weight="fill" className="text-exodus-gold" />
          <p className="eyebrow gold-text">Before you go —</p>
        </div>
        <h3 className="font-display text-4xl leading-tight">
          Most prospects discover they're <span className="gold-text italic">one product away</span> from a tax-free retirement.
        </h3>
        <p className="text-sm text-exodus-muted mt-6 leading-relaxed">
          Eight questions. Four minutes. You'll get a clear pointer to which strategy fits your numbers — Annuity, IUL, or Whole Life.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/quiz"
            data-testid="exit-intent-cta"
            onClick={() => setOpen(false)}
            className="btn-gold inline-flex items-center gap-3"
          >
            Find my fit now
          </Link>
          <button
            onClick={() => setOpen(false)}
            data-testid="exit-intent-dismiss"
            className="text-sm text-exodus-muted hover:text-exodus-text px-6 py-4"
          >
            Not yet
          </button>
        </div>
      </div>
    </div>
  );
}
